<template>
<div class="chapter">
<div class="inner_page">
<a id="page_6"></a>
<h2 class="fm-title">ABBREVIATIONS</h2>
<table>
<tbody><tr>
<td>BEC</td>
<td>British Electric Car Co Ltd, Trafford Park, Manchester</td>
</tr>
<tr>
<td>BET</td>
<td>British Electric Traction</td>
</tr>
<tr>
<td>BTH</td>
<td>British Thomson-Houston Co Ltd</td>
</tr>
<tr>
<td>EMB</td>
<td>Electro-Mechanical Brake Co Ltd</td>
</tr>
<tr>
<td>ER&amp;TCW</td>
<td>Electric Railway &amp; Tramway Carriage Works Ltd</td>
</tr>
<tr>
<td>L&amp;CBER</td>
<td>Llandudno &amp; Colwyn Bay Electric Railway</td>
</tr>
<tr>
<td>LCCTT</td>
<td>London County Council Tramways Trust</td>
</tr>
<tr>
<td>LPTB</td>
<td>London Passenger Transport Board</td>
</tr>
<tr>
<td>LRTA</td>
<td>Light Rapid Transit Association</td>
</tr>
<tr>
<td>LRTL</td>
<td>Light Railway Transport League</td>
</tr>
<tr>
<td>LTE</td>
<td>London Transport Executive</td>
</tr>
<tr>
<td>LTHG</td>
<td>London Tramways History Group</td>
</tr>
<tr>
<td>LUT</td>
<td>London United Tramways</td>
</tr>
<tr>
<td>M&amp;G</td>
<td>Mountain &amp; Gibson</td>
</tr>
<tr>
<td>M&amp;T</td>
<td>Maley &amp; Taunton</td>
</tr>
<tr>
<td>MET</td>
<td>Metropolitan Electric Tramways</td>
</tr>
<tr>
<td>MTMS</td>
<td>Manchester Tramway/Transport Museum Society</td>
</tr>
<tr>
<td>PET</td>
<td>Potteries Electric Traction Co Ltd</td>
</tr>
<tr>
<td>SHMD</td>
<td>Stalybridge, Hyde, Mossley &amp; Dukinfield Tramways &amp; Electricity Board</td>
</tr>
<tr>
<td>SLT</td>
<td>South Lancashire Tramways</td>
</tr>
<tr>
<td>South Met</td>
<td>South Metropolitan Electric Tramways &amp; Lighting Co Ltd</td>
</tr>
<tr>
<td>STMS/STTS</td>
<td>Scottish Tramway Museum Society/Scottish Tramway &amp; Transport Society</td>
</tr>
<tr>
<td>TLRS</td>
<td>Tramway &amp; Light Railway Society</td>
</tr>
<tr>
<td>UDC</td>
<td>Urban District Council</td>
</tr>
<tr>
<td>UEC</td>
<td>United Electric Car Co Ltd</td>
</tr>
</tbody></table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Abbreviations.vue?05d28cf1